import { allTrackers } from "app/services/track/track";

import createSignalsAlertsTrackingService from "./factory";

const signalsAlertsTrackingService = createSignalsAlertsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default signalsAlertsTrackingService;
